import React from 'react';
import { calculateProgress } from '../../utils/resolutionUtils';
import { useLanguage } from '../../contexts/LanguageContext';
import StatusBadge from '../Common/StatusBadge';

const CountResolutionUI = ({
	resolution,
	isUpdateAllowed,
	isUpdating,
	onUpdate,
	onDecrypt,
	isDeleteAllowed,
	onDelete,
}) => {
	const { t } = useLanguage();

	const handleIncrement = () => {
		onUpdate(
			resolution.id,
			{
				...resolution,
				completedCount: resolution.completedCount + 1,
			},
			t
		);
	};

	if (!resolution.count) {
		return <div className='mb-4 text-sm text-gray-500'>No count specified</div>;
	}

	return (
		<div className='bg-white border border-gray-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow'>
			{/* Resolution Text */}
			<div className='mb-3'>
				<h3 className='text-lg font-semibold text-gray-900 mb-1'>{resolution.text}</h3>
				{resolution.isEncrypted && (
					<span className='inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800'>
						🔒 {t('private')}
					</span>
				)}
			</div>
			<div className='mb-4'>
				<div>
					<div className='flex justify-between items-center mb-2'>
						<span className='text-sm text-gray-600'>{t('progress')}</span>
						<span className='text-sm font-medium'>
							{resolution.completedCount}/{resolution.count}
						</span>
					</div>
					<div className='w-full bg-gray-200 rounded-full h-2'>
						<div
							className='bg-blue-600 h-2 rounded-full transition-all duration-300'
							style={{ width: `${Math.min(calculateProgress(resolution), 100)}%` }}
						></div>
					</div>
					<div className='text-right mt-1'>
						<span className='text-xs text-gray-500'>{calculateProgress(resolution)}%</span>
					</div>
				</div>
			</div>

			{/* Status Badge */}
			<div className='mb-4'>
				<StatusBadge statusCode={resolution.statusCode} status={t(resolution.statusCode)} />
			</div>

			<div className='flex items-center justify-between'>
				<div className='flex items-center space-x-2'>
					{isUpdateAllowed &&
						resolution.statusCode !== 'completed' &&
						resolution.completedCount < resolution.count && (
							<button
								onClick={handleIncrement}
								disabled={isUpdating}
								className={`px-3 py-1 text-white rounded-md text-sm ${
									isUpdating
										? 'bg-gray-400 cursor-not-allowed'
										: 'bg-green-500 hover:bg-green-600 cursor-pointer'
								}`}
								title='Increment progress'
							>
								+1
							</button>
						)}

					{resolution.isEncrypted && (
						<button
							onClick={() => onDecrypt(resolution.id)}
							className='px-3 py-1 bg-yellow-500 text-white rounded-md text-sm hover:bg-yellow-600'
							title='Decrypt resolution'
						>
							🔓 {t('decrypt')}
						</button>
					)}
				</div>
				{isDeleteAllowed && (
					<button
						onClick={() => onDelete(resolution.id, t)}
						className='px-3 py-1 bg-red-500 text-white rounded-md text-sm hover:bg-red-600'
						title={t('delete')}
					>
						🗑️ {t('delete')}
					</button>
				)}
			</div>
		</div>
	);
};

export default CountResolutionUI;
